import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { FC } from 'react';

type Props = {
    isMobile?: boolean;
};

const SettlementsDetailsSkeleton: FC<Props> = ({ isMobile }) => {
    return (
        <div
            className={cn(
                'p-6 flex-1 flex items-center gap-4 border border-popover-100 rounded-xl bg-popover-10',
                isMobile && 'p-4',
            )}
        >
            <Skeleton className="size-5 m-1.5 rounded-full" />
            <div className="flex-1">
                <Skeleton className={cn('h-3 w-5/8 my-2', isMobile && 'h-2.5 w-full')} />
                <Skeleton className={cn('h-3 w-6/8 my-1', isMobile && 'h-2.5 w-full')} />
            </div>
            {!isMobile && <Skeleton className="h-5 w-10 my-1.5 ml-auto rounded-full" />}
        </div>
    );
};

export default SettlementsDetailsSkeleton;
